<p-confirmDialog key="import" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="confirmimport" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="TopMenu">
	<h4>Import Format:</h4>

	<table>
		<tr>
			<th>1</th>
			<th>2</th>
			<th>3</th>
			<th>4</th>
			<th>5</th>
			<th>6</th>
			<th>7</th>
		</tr>
		<tr>
			<th>Student ID</th>
			<th>Bus Number</th>
			<th>Bus Description</th>
			<th>Bus Type Route Number</th>
			<th>Bus Route Type Description</th>
			<th>Bus Route Number</th>
			<th>Bus Route Description</th>
		</tr>
	</table>

	<div class="InfoGrid">
		<label>Student ID:</label>
		<p>From CAASS</p>

		<label>Bus Number:</label>
		<p>Unique alpha-numeric bus code ex. 100, A101, G7, etc.</p>

		<label>Bus Description:</label>
		<p>(OPTIONAL you can leave it blank) extra description for the bus ex. Green Bus 1, Taxi JML-0876 etc.</p>

		<label>Bus Type Route Number:</label>
		<p>Unique alpha-numeric route type code ex. 1, AM, PM, etc.</p>

		<label>Bus Type Route Description:</label>
		<p>(OPTIONAL you can leave it blank) Description for route types ex. Morning, Afternoon, Field-Trip, etc.</p>

		<label>Bus Route Number:</label>
		<p>Unqiue alpha-numeric route type code ex. North Mtn 1, FLD1, 100, etc.</p>

		<label>Bus Route Description:</label>
		<p>(OPTIONAL you can leave it blank) Description for the bus route ex. Bus 100 Morning, High School AM 1, Field Trip to Gettysburg, etc.</p>

		<label style="color: orangered">NOTE:</label>
		<p style="color: orangered">
			It is recommened that you export your data (using the Export button), then make changes to the data, and finally import it from this popup.
		</p>
	</div>
</div>

<!--Options-->
<div class="GridMenu">
	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="FormatOption" [(ngModel)]="FormatOption">
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>

	<label>File to Import:</label>
	<div class="FilePickerMenu">
		<label class="InfoText">{{ ImportFile?.name }}</label>
		<button class="btn btn-primary" (click)="onSelectFile()">Select File</button>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<input id="ImportInput" name="ImportInput" type="file" style="display: none" (change)="onFileToImportChange($event)" />

	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onImport()">Import</button>
	<button [disabled]="IsProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
